function getDetailRoute() {
	return {
		path: 'detail',
		meta: {
			title: '标准详情',
			type: 'detail'
		},
		component: () => import('@/views/standard/detail.vue'),
	}
}

export const standard = [{
	path: "/standard/26",
	redirect: '/standard/26/28',
	meta: {
		title: "国际标准",
		is_flag: false
	},
	component: () => import('@/views/empty.vue'),
	children: [{
		path: "/standard/26/28",
		meta: {
			title: "液压标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/26/75",
		meta: {
			title: "气动标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/26/76",
		meta: {
			title: "液力标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/26/77",
		meta: {
			title: "橡胶密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/26/78",
		meta: {
			title: "机械密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/26/79",
		meta: {
			title: "填料密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/26/80",
		meta: {
			title: "污染控制标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}]
}, {
	path: "/standard/27",
	redirect: '/standard/27/81',
	meta: {
		title: "国家标准",
		is_flag: false
	},
	component: () => import('@/views/empty.vue'),
	children: [{
		path: "/standard/27/81",
		meta: {
			title: "液压标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/27/29",
		meta: {
			title: "气动标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/27/82",
		meta: {
			title: "液力标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/27/83",
		meta: {
			title: "橡胶密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/27/84",
		meta: {
			title: "机械密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/27/85",
		meta: {
			title: "填料密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/27/86",
		meta: {
			title: "污染控制标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	},]
}, {
	path: "/standard/73",
	redirect: '/standard/73/87',
	meta: {
		title: "行业标准",
		is_flag: false
	},
	component: () => import('@/views/empty.vue'),
	children: [{
		path: "/standard/73/87",
		meta: {
			title: "液压标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/73/88",
		meta: {
			title: "气动标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/73/89",
		meta: {
			title: "液力标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/73/90",
		meta: {
			title: "橡胶密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/73/91",
		meta: {
			title: "机械密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/73/92",
		meta: {
			title: "填料密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/73/93",
		meta: {
			title: "污染控制标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}]
}, {
	path: "/standard/74",
	redirect: '/standard/74/94',
	meta: {
		title: "团体标准",
		is_flag: false
	},
	component: () => import('@/views/empty.vue'),
	children: [{
		path: "/standard/74/94",
		meta: {
			title: "液压标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/74/95",
		meta: {
			title: "气动标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/74/96",
		meta: {
			title: "液力标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/74/97",
		meta: {
			title: "橡胶密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/74/98",
		meta: {
			title: "机械密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/74/99",
		meta: {
			title: "填料密封标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}, {
		path: "/standard/74/100",
		meta: {
			title: "污染控制标准"
		},
		children: [getDetailRoute()],
		component: () => import('@/views/standard/index.vue')
	}]
}]